import React from 'react';
import PropTypes from 'prop-types';
import TypographyDraft from '../TypographyDraft';
import injectSheet from 'react-jss';
import LinkButton from '../LinkButton';
import classNames from 'classnames';
import { getTextColorsFromSection } from '../lib/colors';
import Section from '../Section';

function CTASection({ classes, event, site, section, direction }) {
  const { data, styles } = section;
  const buttons = data.buttons && data.buttons.slice(0, 2);
  const colors = getTextColorsFromSection(site, section);

  return (
    <Section site={site} section={section} className={classes.root}>
      <div
        className={classNames(
          classes.contentWrapper,
          direction === 'column' && classes.contentWrapperColumn,
        )}
        style={styles.content}
      >
        <TypographyDraft
          component="h3"
          className={classes.title}
          style={{ ...colors.title, ...styles.text }}
          paragraph={direction === 'column'}
          data={data.title}
        />

        <div
          className={classNames(
            classes.buttonWrapper,
            direction === 'column' && classes.buttonWrapperColumn,
          )}
        >
          {buttons &&
            buttons.map((button, i) => (
              <LinkButton
                key={button.id || i}
                section={section}
                site={site}
                event={event}
                button={button}
                className={classes.button}
                style={styles.buttons && styles.buttons[i]}
              >
                {button.title}
              </LinkButton>
            ))}
        </div>
      </div>
    </Section>
  );
}

CTASection.propTypes = {
  classes: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  site: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
  direction: PropTypes.oneOf(['row', 'column']),
};

CTASection.defaultProps = {
  direction: 'row',
};

const stylesheet = theme => ({
  root: {
    padding: [theme.spacing.xlarge, theme.spacing.large],
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: [theme.spacing.large, theme.spacing.medium],
    },
  },
  contentWrapperColumn: {
    flexDirection: 'column',
  },
  contentWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      flexDirection: 'column',
    },
  },
  title: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: 2 * theme.spacing.unit,
    },
  },
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      marginLeft: 5 * theme.spacing.unit,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  buttonWrapperColumn: {
    [theme.breakpoints.up('sm')]: {
      marginLeft: 0,
      flexDirection: 'row',
    },
  },
  button: {
    width: '100%',
  },
});

export default injectSheet(stylesheet)(CTASection);



// WEBPACK FOOTER //
// ./src/site-render/src/CTASection/CTASection.js